import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./locales";
import ProLayout, { PageHeaderWrapper } from "@ant-design-vue/pro-layout";

// import "./mock"; // 开发环境模拟数据使用，正式环境需注释掉
import bootstrap from "./core/bootstrap"; // 变量初始化
import "./core/use"; //组件懒加载
import "./permission"; //权限控制
import "./global.less";

Vue.config.productionTip = false;

Vue.component("pro-layout", ProLayout);
Vue.component("page-header-wrapper", PageHeaderWrapper);

new Vue({
  router,
  store,
  i18n,
  created: bootstrap,
  render: h => h(App)
}).$mount("#app");
